import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import {
	EmailFieldRHF,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormMaskedTextFieldWithLabel,
	RHookFormTextFieldWithLabel,
	SinNumberRHF,
} from "@websential/cosmic-v20";

import { FC } from "react";

// import { RHookFormDatePicker } from "../../RHookFormDatePicker";

interface IEmployeeInfoSetupFieldsPanel {
	sequenceNumber: any
	employeePermissionsData: any
	employeeDDL: any
	onEmployeeSelectionChangeHandler: (selected: any) => void
}
export const EmployeeInfoSetupFieldsPanel: FC<
	IEmployeeInfoSetupFieldsPanel
> = ({ sequenceNumber, employeePermissionsData, employeeDDL, onEmployeeSelectionChangeHandler }) => {
	// RESPONSIVE
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
	const mobileTabOrSmallLaptopScreen = isMobile || isSmallScreen;


	return (
		<>
			{mobileTabOrSmallLaptopScreen && <EnhancedDropDownRHFWithLabel
				label="Load Employee"
				selectName="employee"
				testId={`employee`}
				labelPosition={LabelPosition.Top}
				items={employeeDDL ?? []}
				onSelectionChangeHandler={onEmployeeSelectionChangeHandler}
				showEmpty
			/>}
			<EnhancedDropDownRHFWithLabel
				label="Employee Type"
				selectName="employeeType"
				testId={`Gender`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Regular Employee", value: 200 },
					{ label: "Only for T4/RL-1", value: 100 },
				]}
				selectedItem={200}
				labelColumns={4}
				fieldColumns={8}
			/>
			<Box sx={{ fontSize: ".875rem", color: "rgba(0, 0, 0, 0.6)", marginBottom: "35px" }}>
				ID&nbsp;&nbsp;&nbsp;<span style={{ fontWeight: "bold" }}>{sequenceNumber}</span>
			</Box>
			<RHookFormTextFieldWithLabel
				label="Custom ID"
				id="employeeId"
				testId={`employee-id`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormTextFieldWithLabel
				label="First Name"
				id="firstName"
				testId={`First-Name`}
				labelPosition={LabelPosition.Top}
			// required
			/>
			<RHookFormTextFieldWithLabel
				label="Last Name"
				id="lastName"
				testId={`last-Name`}
				labelPosition={LabelPosition.Top}
			// required
			/>
			<RHookFormTextFieldWithLabel
				label="Initial"
				id="initial"
				testId={`initial`}
				labelPosition={LabelPosition.Top}
				labelColumns={4}
				fieldColumns={8}
			/>
			{/* <SinNumberRHF
				id="socialInsuranceNumber"
				label="Social Insurance"
				required={true}
				labelPosition={LabelPosition.Top}
				labelColumns={4}
				fieldColumns={8}
				testId="socialInsuranceNumber"
			/> */}
			{/* <EmailFieldRHF
				id="email"
				label="Email"
				required={true}
				labelPosition={LabelPosition.Top}
				// labelColumns={6}
				// fieldColumns={6}
				placeholder="mibaig@gmail.com"
				testId="email"
			/> */}
			<RHookFormDatePicker
				name="dateOfBirth"
				testId="date-of-birth"
				label="Date of Birth"
				labelPosition={LabelPosition.Top}
				format="M dd, yy"
				// required
				labelColumns={4}
				fieldColumns={8}
				disabled={employeePermissionsData && employeePermissionsData.calculatePayroll}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Gender"
				selectName="gender"
				testId={`Gender`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Male", value: 200 },
					{ label: "Female", value: 100 },
				]}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
			/>
		</>
	);
};
